import { render, staticRenderFns } from "./SharingShare.vue?vue&type=template&id=346f915e"
import script from "./SharingShare.vue?vue&type=script&lang=js"
export * from "./SharingShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports